/**
 * Main JavaScript Entry Point
 * 
 * This file imports all styles and initializes all JavaScript components.
 */

// Import styles
import '../sass/tailwind.css';
import '../sass/index.scss';

// Import components
import initCarousel from './components/carousel';
import initPagination from './components/pagination';
import initNavigation from './components/navigation';
import initMenuEvents from './components/menu-events';

// Initialize all components when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
	initCarousel();
	initPagination();
	initNavigation();
	initMenuEvents();
});
